/*
 * @Descripttion: 主文件
 * @version:
 * @Author: leo.liu
 * @Date: 2021-08-29 06:43:07
 * @LastEditors: qianlishi
 * @LastEditTime: 2021-12-13 10:22:37
 */
import { $getUuid, $deepclone } from '@/utils/methods';
import { widgetTool } from "./main";
const screenConfig = {
  code: "screen",
  type: "screen",
  label: "大屏设置",
  icon: "",
  options: {
    setup: [
      {
        type: "el-input-number",
        label: "大屏宽度",
        name: "width",
        required: false,
        placeholder: "px",
        value: "1200",
        disabled: true
      },
      {
        type: "el-input-number",
        label: "大屏高度",
        name: "height",
        required: false,
        placeholder: "px",
        value: "1080",
        disabled: true
      },
      // {
      //   type: "el-input-text",
      //   label: "标题",
      //   name: "title",
      //   require: false,
      //   placeholder: "",
      //   value: "大屏",
      // },
      // {
      //   type: "el-input-textarea",
      //   label: "大屏简介",
      //   name: "description",
      //   required: false,
      //   placeholder: "",
      // },
      {
        type: "vue-color",
        label: "背景颜色",
        name: "backgroundColor",
        required: false,
        placeholder: "",
        value: "#FBFCFE",
      },
      {
        type: "style-type-change",
        label: "样式",
        name: "style",
        required: false,
        placeholder: "",
        value: "normal",
      },
      // {
      //   type: "custom-upload",
      //   label: "图片地址",
      //   name: "backgroundImage",
      //   required: false,
      //   placeholder: "",
      //   value:
      //     "https://report.anji-plus.com/file/download/bf566e48-ccad-40e1-8ee9-228427e5466b",
      // },
      // {
      //   type: "el-input-number-percent",
      //   label: "缩放比例",
      //   name: "scale",
      //   required: false,
      //   placeholder: "px",
      //   value: "100",
      // },
    ],
    data: [
      {
        type: "el-radio-group",
        label: "数据类型",
        name: "dataType",
        require: false,
        placeholder: "",
        selectValue: true,
        selectOptions: [
          {
            code: "staticData",
            name: "静态数据",
          },
          {
            code: "dynamicData",
            name: "动态数据",
          },
        ],
        value: "dynamicData",
      },
      {
        type: "dycustComponents",
        label: "",
        name: "dynamicData",
        required: false,
        placeholder: "",
        relactiveDom: "dataType",
        relactiveDomValue: "dynamicData",
        chartType: "screen",
        uuid: $getUuid(),
        dictKey: "TEXT_PROPERTIES", //表格的暂不起作用
        value: {},
      },
    ],
    position: [],
  },
};
const widgetTools = [...widgetTool];

const getToolByCode = function (code) {
  // 获取大屏底层设置属性
  if (code == "screen") {
    return $deepclone(screenConfig);
  }
  // 获取组件
  let item = widgetTools.find(function (item, index, arrs) {
    return item.code === code;
  });
  return $deepclone(item);
};

export { widgetTools, getToolByCode };
